var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vCenter zanbtndiv",on:{"click":function($event){_vm.praise()}}},[_c('img',{attrs:{"src":_vm.minezan=='0'?'/img/icon/zan.png':'/img/icon/zaned.png',"alt":""}}),_vm._v(" "),(_vm.praisecount==0)?_c('div',{staticClass:"btntext"},[_vm._v("\n    赞\n  ")]):_c('div',{staticClass:"btntext"},[_vm._v("\n    "+_vm._s(_vm.praisecount)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36180886","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/zan/um-zan.vue
// module id = 97
// module chunks = 0